export const JournalBannerSectionFour = () => {
  return null;
};
